import { SHOP_TYPES } from "./../types";

export const addRecentlyViewed = item => ({
  type: SHOP_TYPES.SET_RECENTLY_VIEWED,
  payload: item,
});
